module.exports = __webpack_public_path__ + "static/media/160421-GlobalNavIA_v5.015.9ea2ac57.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/misc/160421-GlobalNavIA_v5/160421-GlobalNavIA_v5.015.png
// module id = 209
// module chunks = 0